import type { RecruitingFormSchema } from '../schemas';

export const defaultValues: Readonly<RecruitingFormSchema> = {
  id: -1,
  first_name: '',
  last_name: '',
  profile_image: [],
  linked_in: '',
  email: '',
  phone_numbers: [],
  recruiting_tags: [],
  recruiting_job_categories: [],
  hiring_criteria_categories: [],
  resume: [],
  additional_documents: [],
  notes: '',
};
